export default "__VITE_ASSET__DEuRhClz__"